<!--File: cgp-app-bar-user-menu.template.html-->
<!--Author: Joseph M Diaz-->
<!--Date: 4/24/2017-->
<!--Desc: Template for the user menu. -->
<!--Other Contributors:-->

<div class="cgp-user-menu">
   <span class="cgp-user-menu-text xs-hide">
      Session Expires in: {{remainingTime}} minutes
   </span>
   <mat-divider class="d-inline mr-2" [vertical]="true"></mat-divider>
   <span class="cgp-user-menu-text xs-hide">{{userMenuText}}</span>
   <button mat-button class="cgp-user-menu-button" [matMenuTriggerFor]="userMenu">
      <mat-icon class="cgp-user-menu-icon">
         <i class="fa fa-user"></i>
      </mat-icon>
   </button>
   <mat-menu #userMenu="matMenu" [overlapTrigger]="false" yPosition="below" class="cgp-user-menu-popup">
      <span class="px-2">{{ userName }}</span>
      <div *ngFor="let menuItem of userMenuItems">
         <button mat-menu-item (click)="onItemClick(menuItem)">
            <i *ngIf="menuItem.showIcon" class="{{menuItem.icon}}"></i><span>{{menuItem.name}}</span>
         </button>
      </div>
   </mat-menu>
</div>